<template>
  <div class="grotec-side-collapse side-collapse collapse" style="position: fixed">
      <departments-dropdown></departments-dropdown>
  </div>
</template>
<script>
  import DepartmentsDropdown from "./departments-dropdown";
  export default {
    name: 'hidden-left-menu',
    components: { DepartmentsDropdown }
  }
</script>